"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelFilePatchOutputFromUnknown = exports.ModelFilePatchOutput = exports.Files = exports.compareStatuses = exports.Status = exports.getModelId = exports.ModelPatch = exports.modelsFromUnknown = exports.modelSummariesFromUnknown = exports.ModelSummary = exports.Model = void 0;
const Toastie = __importStar(require("./toastieModel"));
exports.Model = Toastie.Api.ModelOutput.Data;
exports.ModelSummary = Toastie.Api.ModelSummaryOutput.Data;
exports.modelSummariesFromUnknown = Toastie.Api.ModelSummaryOutput.arrayFromUnknown;
exports.modelsFromUnknown = Toastie.Api.ModelOutput.arrayFromUnknown;
exports.ModelPatch = Toastie.Api.ModelPatchInput.Data;
const getModelId = (productId, articleType) => Toastie.Api.ModelId.toString({ productId, articleType });
exports.getModelId = getModelId;
exports.Status = Toastie.Base.Status;
const compareStatuses = (first, second) => {
    const values = {
        'not-ready': 4,
        ready: 3,
        rejected: 2,
        approved: 1,
    };
    const status = [first, second].sort((a, b) => values[b] - values[a])[0];
    return status;
};
exports.compareStatuses = compareStatuses;
exports.Files = Toastie.Base.ModelFiles;
exports.ModelFilePatchOutput = Toastie.Api.ModelFilePatchOutput.Data;
exports.modelFilePatchOutputFromUnknown = Toastie.Api.ModelFilePatchOutput.fromUnknown;
